import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 7l5 5l-5 5","key":"svg-0"}],["path",{"d":"M12 19l7 0","key":"svg-1"}]]

/**
 * IconTerminal
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdGVybWluYWwiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTUgN2w1IDVsLTUgNSIgLz4KICA8cGF0aCBkPSJNMTIgMTlsNyAwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/terminal
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconTerminal = createReactComponent('outline', 'terminal', 'Terminal', __iconNode);

export default IconTerminal;